<mat-form-field [subscriptSizing]="subscriptSizing()" color="accent" class="full-width-form">
	<mat-label>
		<mat-icon matSuffix [fontIcon]="suffixFontIcon() ?? 'fa-alarm-clock'" fontSet="fad" />
		{{ labelToken() ?? T.LABEL_DURATION | translate }}
	</mat-label>
	<input
		[formControl]="formCtrl()"
		inputmode="numeric"
		matInput
		pattern="[0-9]*"
		[max]="max()"
		[min]="min()"
		type="number"
		class="digitInput"
	/>
	<span class="labelSuffix" matTextSuffix>{{ T.LABEL_MINUTES | translate }}</span>
	@if (formCtrl().hasError("required")) {
		<mat-error>{{ T.ERROR_REQUIRED | translate }}</mat-error>
	}
	@if (formCtrl().hasError("min") && min() === 1) {
		<mat-error>{{ T.ERROR_DURATION_GREATER_ZERO | translate }}</mat-error>
	}
	@if (formCtrl().hasError("min") && min() === 0) {
		<mat-error>{{ T.SHARED_POINT_INPUT_NOT_NEGATIVE | translate }}</mat-error>
	}
	@let hintToken = this.hintToken();
	@if (hintToken) {
		<mat-hint>{{ hintToken | translate }}</mat-hint>
	}
</mat-form-field>
